import { styled } from '@mui/material';
import { dividerClasses } from '@mui/material/Divider';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import { typographyClasses } from '@mui/material/Typography';
import clsx from 'clsx';
export const CustomTooltip = styled(({
  className,
  color = 'inverted',
  ...props
}) => <Tooltip {...props} classes={{
  popper: clsx(className, `CustomTooltip-${color}`)
}} />)(({
  theme
}) => ({
  [`&.CustomTooltip-inverted`]: {
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: 'var(--color-tooltip)',
      color: 'var(--color-tooltip-foreground)'
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: 'var(--color-tooltip)'
    },
    // Theme surface colors (text.primary, divider) are unreadable on the
    // inverted surface — remap children to the tooltip foreground.
    [`& .${typographyClasses.root}`]: {
      color: 'var(--color-tooltip-foreground)'
    },
    [`& .${dividerClasses.root}`]: {
      borderColor: 'color-mix(in srgb, var(--color-tooltip-foreground) 25%, transparent)',
      '&::before, &::after': {
        borderColor: 'color-mix(in srgb, var(--color-tooltip-foreground) 25%, transparent)'
      }
    }
  },
  [`&.CustomTooltip-normal`]: {
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: 'var(--color-raised)',
      color: 'var(--color-foreground)',
      boxShadow: theme.shadows[1],
      border: `1px solid var(--color-border)`
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: 'var(--color-raised)',
      '&::before': {
        border: `1px solid var(--color-border)`
      }
    },
    // Typography follows the (mode-aware) MUI theme; Divider gets the same
    // border token as the tooltip edge for a consistent hairline.
    [`& .${dividerClasses.root}`]: {
      borderColor: 'var(--color-border)',
      '&::before, &::after': {
        borderColor: 'var(--color-border)'
      }
    },
    // Nudge arrow slightly outward so it sits on the border, not inside the body
    [`&[data-popper-placement*="bottom"] .${tooltipClasses.arrow}`]: {
      top: -0.5
    },
    [`&[data-popper-placement*="top"] .${tooltipClasses.arrow}`]: {
      bottom: -0.5
    },
    [`&[data-popper-placement*="left"] .${tooltipClasses.arrow}`]: {
      right: -0.5
    },
    [`&[data-popper-placement*="right"] .${tooltipClasses.arrow}`]: {
      left: -0.5
    }
  }
}));